import React from "react";
import { Box } from "@curves/ui-base";
import { HTMLViewPdfComponent } from "@icoach/components/";

const HTMPViewTestPage = React.forwardRef((props, ref) => {
    const url = "https://localhost:5011/document/membership?version=105";
    // const url = "https://localhost:5011/document/membership?version=104";
    // const url = "https://localhost:5011/document/membership?version=103";
    // const url = "https://localhost:5011/document/membership?version=102";
    // const url = "https://localhost:5011/document/membership?version=101";
    // const url = "https://localhost:5011/document/inbody";
    // const url = "https://localhost:5011/document/14622/measure/multiple-information/?memberID=1837&measureDate=2025-07-22T09%3A19%3A28.997";
    // const url = "https://localhost:5011/document/14622/measure/sport-advise/?healthDeclarationContractID=688";
    
    return (
        <Box className="main-container-spacing" style={{ position: "relative", height: "100vh" }}>
            <HTMLViewPdfComponent htmlUrl={url} />
        </Box>
    );
});

export default HTMPViewTestPage;
